<template>
  <div>
    <div ref='folderSubscriptionModal' aria-hidden="true" class="modal fade hidden" role="dialog" tabindex='-1'>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
        <h5 class="modal-title mt-0">
          <span>{{ $t('folder_show.activities.subscribe_to_folder') }}:</span>
          {{ folder.name }}
        </h5>
        </div>
        <div class='modal-body text-left'>
          <form ref="formFolderSubscribeEvent">
          <p>{{ $t('folder_show.activities.subscribe_updates') }}:</p>
          <label class="checkbox-container">
            {{ $t('folder_show.activities.event_groups.file_uploads') }}
            <input type="checkbox" name="event_subscriptions[event_group][]" value="file_uploads" :checked="check_event_group('file_uploads')">
            <span class="checkmark" data-toggle="tooltip" title=""></span>
          </label>
          <label class="checkbox-container">
            {{ $t('folder_show.activities.event_groups.file_removal') }}
            <input type="checkbox" name="event_subscriptions[event_group][]" value="file_removal" :checked="check_event_group('file_removal')">
            <span class="checkmark" data-toggle="tooltip" title=""></span>
          </label>
          <label class="checkbox-container">
            {{ $t('folder_show.activities.event_groups.file_replacements') }}
            <input type="checkbox" name="event_subscriptions[event_group][]" value="file_replacements" :checked="check_event_group('file_replacements')">
            <span class="checkmark" data-toggle="tooltip" title=""></span>
          </label>

          <br/>
          <p>{{ $t('folder_show.activities.notify_via') }}:</p>
          <label class="checkbox-container">
            {{ $t('folder_show.activities.notify_email') }}
            <input type="checkbox" name="event_subscriptions[activity_notify_via][]" value="email" :checked="check_notify_via('email')">
            <span class="checkmark" data-toggle="tooltip"></span>
          </label>
          <label class="checkbox-container">
            {{ $t('folder_show.activities.notify_app') }}
            <input type="checkbox" name="event_subscriptions[activity_notify_via][]" value="app" :checked="check_notify_via('app')">
            <span class="checkmark" data-toggle="tooltip"></span>
          </label>

          <br/>
          <p>{{ $t('folder_show.activities.frequency_days') }}:</p>
          <label class="radio-container">
            {{ $t('folder_show.activities.notify_immediately') }}
            <input type="radio" name="folder_subscription[activity_notify_days]" value="0" :checked="subscription.activity_notify_days === 0 || !isSubscribed">
            <span class="radiomark" data-toggle="tooltip"></span>
          </label>
          <label class="radio-container">
            {{ $t('folder_show.activities.notify_weekly') }}
            <input type="radio" name="folder_subscription[activity_notify_days]" value="7" :checked="subscription.activity_notify_days === 7">
            <span class="radiomark" data-toggle="tooltip"></span>
          </label>
          <label class="radio-container">
            {{ $t('folder_show.activities.bi_weekly') }}
            <input type="radio" name="folder_subscription[activity_notify_days]" value="14" :checked="subscription.activity_notify_days === 14">
            <span class="radiomark" data-toggle="tooltip"></span>
          </label>
          <label class="radio-container">
            {{ $t('folder_show.activities.monthly') }}
            <input type="radio" name="folder_subscription[activity_notify_days]" value="30" :checked="subscription.activity_notify_days === 30">
            <span class="radiomark" data-toggle="tooltip"></span>
          </label>
          </form>
        </div>
        <div class="modal-footer">
          <input v-if='isSubscribed' @click.prevent='folderUnsubscribe' type='reset' class="btn btn-outline-danger float-right" :value="$t('folder_show.activities.unsubscribe')" :disabled='disabledButton' />
          <button type='submit' class="btn btn-primary float-right" @click.prevent="folderSubscribe" :disabled='disabledButton'>
            {{ ((isSubscribed) ? $t('folder_show.activities.update_button') : $t('folder_show.activities.subscribe')) }}
          </button>
        </div>
       </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        currentFolder: {},
        disabledButton: false,
        isShared: false,
      }
    },
    computed: {
      subscription() {
        return this.state.folderSubscription || {}
      },
      isSubscribed(){
        return (Object.keys(this.subscription).length > 0)
      },
      folder(){
        return this.currentFolder
      },
      folderId(){
        return this.folder.id || null
      },
    },
    created() {
      this.loadFolderSubscription()
    },
    methods: {
      open(folder, isShared) {
        this.currentFolder = folder
        this.isShared = isShared
        this.loadFolderSubscription()
        $(this.$refs.folderSubscriptionModal).modal('show')
      },
      closeModal() {
        $(this.$refs.folderSubscriptionModal).modal('hide')
      },
      check_event_group(event){
        let attr = this.subscription.event_subscriptions
        return attr !== undefined ? attr.event_group.includes(event) : true
      },
      check_notify_via(event){
        let attr = this.subscription.event_subscriptions
        return attr !== undefined ? attr.activity_notify_via.includes(event) : true
      },
      loadFolderSubscription() {
        if(Object.keys(this.folder).length > 0){
          if(this.isShared){
            this.store.getSharedFolderSubscription(this.folder.id)
          }else{
            this.store.getFolderSubscription(this.folder.id)
          }
        }
      },
      folderSubscribe() {
        this.disabledButton = true

        let subscriptionForm = this.$refs.formFolderSubscribeEvent
        let event_groups = subscriptionForm.querySelectorAll("input[name='event_subscriptions[event_group][]']:checked").length
        let notify_via = subscriptionForm.querySelectorAll("input[name='event_subscriptions[activity_notify_via][]']:checked").length
        let frequency = subscriptionForm.querySelectorAll("input[name='folder_subscription[activity_notify_days]']:checked").length

        if(event_groups === 0){
          this.$toastr.error(this.$t('folder_show.activities.errors.select_event_group'))
          return false
        }else if(notify_via === 0){
          this.$toastr.error(this.$t('folder_show.activities.errors.select_notify_via'))
          return false
        }else if(frequency === 0){
          this.$toastr.error(this.$t('folder_show.activities.errors.select_frequency'))
          return false
        }

        let form = new FormData(subscriptionForm)
        if(this.isShared){
          this.store.createSharedFolderSubscription(this.folderId, form).then(() => {
             this.$toastr.success(this.$t('folder_show.activities.successfully_subscribed'))
             this.disabledButton = false
             this.$emit('reload-callback')
            this.store.sendMetrics({name: 'share_folder_subscribe', params: this.$route.params, path: this.$route.fullPath})
          })
        }else{
          this.store.createFolderSubscription(this.folderId, form).then(() => {
             this.$toastr.success(this.$t('folder_show.activities.successfully_subscribed'))
             this.disabledButton = false
             this.$emit('reload-callback')
            this.store.sendMetrics({name: 'folder_subscribe', params: this.$route.params, path: this.$route.fullPath})
          })
        }
        this.loadFolderSubscription()
        this.closeModal()
      },
      folderUnsubscribe() {
        this.disabledButton = true

        if(this.isShared){
          this.store.deleteSharedFolderSubscription(this.folderId, this.subscription.id).then(() => {
            this.$toastr.success(this.$t('folder_show.activities.successfully_unsubscribed'))
            this.disabledButton = false
            this.$emit('reload-callback')
            this.store.sendMetrics({name: 'remove_shared_folder_subscribe', params: this.$route.params, path: this.$route.fullPath})
          })
        }else{
          this.store.deleteFolderSubscription(this.folderId, this.subscription.id).then(() => {
            this.$toastr.success(this.$t('folder_show.activities.successfully_unsubscribed'));
            this.disabledButton = false
            this.$emit('reload-callback')
            this.store.sendMetrics({name: 'remove_folder_subscribe', params: this.$route.params, path: this.$route.fullPath})
          })
        }
        this.loadFolderSubscription()
        this.closeModal()
      }
    }
  }
</script>
